import { createFeature, createReducer, on } from '@ngrx/store';
import { SupplierCreditNoteModel } from '@shared/data-access/models';
import { SupplierCreditNoteAction } from '../actions';

export const featureName = 'supplierCreditNote';

export interface DataState {
  item: SupplierCreditNoteModel | null;
}

export const initialState: DataState = {
  item: null,
};

export const SupplierCreditNoteFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(SupplierCreditNoteAction.loadItemSuccess, (state, prop: { item: SupplierCreditNoteModel }) => ({ ...state, item: prop.item }))
  ),
});

export const { name, reducer } = SupplierCreditNoteFeature;
